import type { RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/payments/benefits",
    name: ROUTE_NAME.PAYMENT_BENEFITS_LIST,
    component: () => import("./views/SubscriberBenefitsView.vue"),
  },
];
